import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
import { InvoiceRow } from "."
import InvoiceHeader from "./invoice-header"
import { CreateInvoiceForm } from ".."

interface InvoicePreviewProps {
  rows: InvoiceRow[]
  total: number
  totalUnitPrice: number
  invoiceData: CreateInvoiceForm
}

const InvoicePreview: React.FC<InvoicePreviewProps> = ({ rows, total, totalUnitPrice, invoiceData }) => (
  <Box sx={{ p: 2, border: "2px solid #e0e0e0", borderRadius: 2, background: "#fcfcfc", position: "relative" }}>
    {/* Optional: Watermark or subtle print border */}
    <InvoiceHeader invoiceData={invoiceData} />
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Items</b>
            </TableCell>
            <TableCell>
              <b>Unit Price</b>
            </TableCell>
            <TableCell>
              <b>Units</b>
            </TableCell>
            <TableCell>
              <b>Amount</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell>{row.item?.label}</TableCell>
              <TableCell>{row.unitPrice}</TableCell>
              <TableCell>{row.units}</TableCell>
              <TableCell>{row.amount}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell align="center">
              <b>Total</b>
            </TableCell>
            <TableCell colSpan={2}>
              <b>{totalUnitPrice.toLocaleString()}</b>
            </TableCell>
            <TableCell colSpan={2}>
              <b>{total.toLocaleString()}</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
)

export default InvoicePreview
